import gql from 'graphql-tag'
import { listLoyaltyCards } from './fragments'

export default gql`
query listLoyaltyCards($params: ListQueryArgs $filter: LoyaltyCardFilterArgs) {
	cashAssist {
		listLoyaltyCards(params: $params filter: $filter) {
			...listLoyaltyCards
		}
	}
}
${listLoyaltyCards}
`
